function judgeIsIos() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1;
}

/**
 * 利用scheme协议h5页面跳转app
 *
*/
const openUrl = url => {
    if(!url.match(/^[\w]+:/)) {
        url = (judgeIsIos() ? 'qunariphone' : 'qunaraphone') + (url.match(':') ? '' : ':') + url;
    }
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
};

export default openUrl;